<template>
  <div>
    <router-link v-if='!outside' :to='href'>
      <slot />
    </router-link>
    <a v-if='outside' target='_blank' :href='href'>
      <slot />
    </a>
  </div>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), md() etc
  props: ['href', 'outside']
}
</script>
